import { useContext } from 'react';
import { OmniverseConfigContext } from '../context/ConfigContext';
import { OmniverseConfig } from '../providers/ConfigProvider';

export function useOmniverseConfig(): OmniverseConfig {
  return useContext(OmniverseConfigContext);
}
